import { useState, useEffect } from "react";
import { DoorOpen } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { useRestaurantContext } from "@/contexts/RestaurantContext";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export function ExitReleasePrintCard() {
  const { activeRestaurant, refetch } = useRestaurantContext();
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    if (activeRestaurant) {
      setEnabled((activeRestaurant as any)?.print_exit_release ?? false);
    }
  }, [activeRestaurant]);

  const handleToggle = async (value: boolean) => {
    if (!activeRestaurant) return;
    setEnabled(value);

    const { error } = await supabase
      .from("restaurants")
      .update({ print_exit_release: value } as any)
      .eq("id", activeRestaurant.id);

    if (error) {
      toast.error("Erro ao salvar configuração");
      setEnabled(!value);
      return;
    }

    toast.success(value ? "Saída Liberada ativada" : "Saída Liberada desativada");
    await refetch();
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg flex items-center gap-2">
          <DoorOpen className="h-5 w-5" />
          Saída Liberada (Comandas)
        </CardTitle>
        <CardDescription>
          Imprime automaticamente um comprovante de "Saída Liberada" ao fechar uma comanda, para ser entregue na portaria
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="flex items-center justify-between rounded-lg border p-4">
          <div>
            <Label className="text-base">Imprimir Saída Liberada</Label>
            <p className="text-sm text-muted-foreground">
              Ao fechar comanda, imprime comprovante com número da comanda, data, funcionário e "LIBERADO!!!"
            </p>
          </div>
          <Switch checked={enabled} onCheckedChange={handleToggle} />
        </div>
      </CardContent>
    </Card>
  );
}
